import React from 'react';
import ReactSelect from 'react-select';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { components } from '../../Utils/ReactSelectComponents';
import { connect } from 'react-redux';
import SaveIcon from '@material-ui/icons/Save';
import CheckIcon from '@material-ui/icons/Check';
import SalesChannelsIcon from '@material-ui/icons/DeviceHub';
import CloseIcon from '@material-ui/icons/Close';
import ApplyIcon from '@material-ui/icons/Update'
import DropdownListAPI from '../../../API/DropdownListAPI';
import CarsListAPI from '../../../API/CarsListAPI';
import ConfirmationDialog from '../../Utils/ConfirmationDialog';
import SnackbarAlert from '../../Utils/SnackbarAlert';
import { handleServerError } from '../../../Utils/Helper';
import { TableSortLabel, TablePagination, CircularProgress, Paper, Dialog, Typography, InputLabel, Toolbar, DialogContent, Button, FormControlLabel, Tooltip, Grid, Table, TableHead, TableBody, LinearProgress, TableCell, TableRow, Divider, DialogActions, Checkbox } from '@material-ui/core';
import { FormatDate, StringAllOptionals } from '../../Utils/GenericFunctions';
import { STARTING_TABLE_PAGE, DEFAULT_ROWS_PER_PAGE, ORDER_BY_COLOR, ORDER_ASCENDING, FP_PHASE, FP_GROUP, NO_TABLE_DATA_MESSAGE } from '../../../Utils/Constants';
import ClearIcon from '@material-ui/icons/LayersClear';

const headerData = [
  { id: 'optionals', label: 'OPCIONAIS', sort: false },
  { id: 'color', label: 'COR', sort: true },
  { id: 'licenseplate', label: 'MATRÍCULA', sort: true },
  { id: 'licenseplatedate', label: 'DATA MATRÍCULA', sort: true },
  { id: 'salechannels', label: 'CANAIS VENDA', sort: false },
  { id: 'reservation', label: 'RESERVA', sort: true },
  { id: 'stock', label: 'STOCK', sort: true }
];

const styles = theme => ({
  paperRoot: {
    width: '100%',
    backgroundColor: '#F6F6F6',
  },
  button: {
    margin: theme.spacing.unit
  },
  buttonSize: {
    width: '36px',
    height: '36px'
  },
  width100: {
    width: '100%',
    textAlign: 'left'
  },
  tblHead: {
    backgroundColor: '#A5A5A5'
  },
  tblHeadT: {
    color: '#ffffff',
    fontSize: '14px',
    padding: '0px 6px'
  },
  tblBorderHead: {
    border: '2px solid #ffffff'
  },
  tblBorder: {
    border: '2px solid #ffffff',
    fontSize: '12px'
  },
  textOptionals: {
    paddingLeft: '6px',
    fontSize: '12px'
  },
  textCenter: {
    textAlign: 'center'
  },
  cellPadding: {
    paddingLeft: '6px'
  },
  headerCellPadding: {
    paddingLeft: '16px'
  },
  tableWrapper: {
    overflowX: 'auto'
  },
  tblRow: {
    backgroundColor: '#F2F2F2',
    '&:hover': {
      backgroundColor: theme.palette.primary.light
    },
    '&:nth-of-type(odd)': {
      backgroundColor: '#E1E1E1',
      '&:hover': {
        backgroundColor: theme.palette.primary.light
      },
    },
    height: '30px'
  },
  gridRoot: {
    paddingTop: '10px'
  },
  iconswidth: {
    width: '36px'
  },
  checkboxSize: {
    width: '24px',
    height: '24px'
  },
  filterPaper: {
    padding: '8px 16px'
  },
  fabProgress: {
    position: 'absolute',
    right: '26px',
    bottom: '8px',
    zIndex: 1
  },
  tblFooter: {
    height: '30px',
    minHeight: '30px'
  },
  pageButton: {
    width: '30px',
    height: '30px',
    margin: '0px 8px'
  },
  tblSort: {
    height: '12px',
    width: '12px',
    margin: '0px 2px'
  },
  //DON'T REMOVE (Used in StringAllOptionals)
  textAquaBlue: {
    color: '#00B1AF'
  },
  textGrassGreen: {
    color: '#009A17'
  },
  //DON'T REMOVE (Used in ReactSelectComponents)
  noOptionsMessage: {
    padding: `${theme.spacing.unit / 2}px`
  },
  input: {
    display: 'flex',
    padding: 0
  }
});


class FirmPurchasesSaleChannels extends React.Component {
  l4ListAPI;

  constructor(props) {
    super(props);
    this.state = {
      openCVDialog: false,
      optionalsSearchData: [],
      colorSearchData: [],
      optionalsSearch: [],
      optionalsSearchIds: [],
      colorSearch: 0,
      saleChannelData: [],
      saleChannelSearch: [],
      reloading: false,
      selectedCars: [],
      selectedSaleChannels: [],
      changedValueDetected: false,
      loading: false,
      success: false,
      openDialog: false,
      confirmationQuestion: '',
      confirmationMessage: '',
      confirmationFunction: () => { },
      cancelFunction: () => { },
      openError: false,
      alertMessage: '',
      tableData: [],
      count: 0,
      page: STARTING_TABLE_PAGE,
      rowsPerPage: DEFAULT_ROWS_PER_PAGE,
      orderBy: ORDER_BY_COLOR,
      order: ORDER_ASCENDING,
      allSelected: false,
      trueFalseOptions: [
        { value: true, label: "Sim"},
        { value: false, label: "Não"},
      ],
      reservationSearch: null,
      stockSearch: null
    };
    this.l4ListAPI = new CarsListAPI();
  }

  componentDidMount() {
    this.setState({ reloading: true });
    const dropdownListDataAPI = new DropdownListAPI();
    dropdownListDataAPI.getAllSalesChannels().then((response) => {
      this.setState({
        saleChannelData: response.data,
        reloading: false
      });
    }).catch((error) => {
      this.setState({
        reloading: false,
        openError: true,
        alertMessage: handleServerError(error)
      });
    });
  };

  getHeaderInformation() {
    this.setState({ reloading: true });
    let L1Id = this.props.negotiationLot.L1ID;
    Promise.all([this.l4ListAPI.getOptionalsByL1Id(L1Id), this.l4ListAPI.getColorsByL1Id(L1Id)]).then((response) => {
      this.setState({
        optionalsSearchData: response[0].data,
        colorSearchData: response[1].data,
        reloading: false
      });
    }).catch((error) => {
      this.setState({
        reloading: false,
        openError: true,
        alertMessage: handleServerError(error)
      });
    });
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  handleClickCancel = () => {
    if (this.state.changedValueDetected === true) {
      this.setState({
        openDialog: true,
        confirmationQuestion: 'Tem a certeza que pretende RETROCEDER sem guardar as alterações?',
        confirmationMessage: 'A informação relativamente às alterações executadas será perdida.',
        confirmationFunction: this.handleClose,
        cancelFunction: this.handleCloseDialog
      });
    }
    else {
      this.handleClose();
    }
  };

  handleClearState = () => {
    this.setState({
      reloading: false,
      loading: false,
      success: false,
      changedValueDetected: false,
      selectedCars: [],
      selectedSaleChannels: [],
      allSelected: false
    })
  }

  handleClearSearchFilter = () => {
    this.setState({
      colorSearch: 0,
      optionalsSearch: [],
      saleChannelSearch: [],
      reservationSearch: null,
      stockSearch: null
    })
  }

  handleClose = () => {
    this.setState({
      openDialog: false,
      openCVDialog: false
    })
    this.handleClearState();
    this.handleClearSearchFilter();
  }

  handleCloseDialog = () => {
    this.setState({ openDialog: false });
  };

  reloadTable() {
    this.setState({ reloading: true });
    this.l4ListAPI.getMinimizedL4List(this.props.negotiationLot.L1ID, STARTING_TABLE_PAGE, this.state.rowsPerPage, this.state.orderBy, this.state.order, this.state.colorSearch.value, this.state.optionalsSearch.map(o => o.value), this.state.saleChannelSearch.map(o => o.value), 
        this.state.reservationSearch != null ? this.state.reservationSearch.value : null, this.state.stockSearch != null ? this.state.stockSearch.value : null).then((response) => {
      this.setState({
        tableData: response.data.CarList,
        count: response.data.NumberFilteredResults,
        page: STARTING_TABLE_PAGE,
        reloading: false
      });
    }).catch((error) => {
      this.setState({
        reloading: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  handleRequestSort = property => event => {
    const orderBy = property;
    let order = 'desc';
    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }
    this.setState({ reloading: true });
    this.l4ListAPI.getMinimizedL4List(this.props.negotiationLot.L1ID, this.state.page, this.state.rowsPerPage, orderBy, order, this.state.colorSearch.value, this.state.optionalsSearch.map(o => o.value), this.state.saleChannelSearch.map(o => o.value),
        this.state.reservationSearch != null ? this.state.reservationSearch.value : null, this.state.stockSearch != null ? this.state.stockSearch.value : null).then((response) => {
      this.setState({
        tableData: response.data.CarList,
        count: response.data.NumberFilteredResults,
        order, orderBy,
        reloading: false
      });
    }).catch((error) => {
      this.setState({
        reloading: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  handleChangePage = (event, page) => {
    this.setState({ allSelected: false, reloading: true });
    this.l4ListAPI.getMinimizedL4List(this.props.negotiationLot.L1ID, page, this.state.rowsPerPage, this.state.orderBy, this.state.order, this.state.colorSearch.value, this.state.optionalsSearch.map(o => o.value), this.state.saleChannelSearch.map(o => o.value), 
        this.state.reservationSearch != null ? this.state.reservationSearch.value : null, this.state.stockSearch != null ? this.state.stockSearch.value : null).then((response) => {
      this.setState({
        tableData: response.data.CarList,
        count: response.data.NumberFilteredResults,
        page: page,
        reloading: false
      });
    }).catch((error) => {
      this.setState({
        reloading: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ reloading: true });
    this.l4ListAPI.getMinimizedL4List(this.props.negotiationLot.L1ID, this.state.page, event.target.value, this.state.orderBy, this.state.order, this.state.colorSearch.value, this.state.optionalsSearch.map(o => o.value), this.state.saleChannelSearch.map(o => o.value),
        this.state.reservationSearch != null ? this.state.reservationSearch.value : null, this.state.stockSearch != null ? this.state.stockSearch.value : null).then((response) => {
      this.setState({
        tableData: response.data.CarList,
        count: response.data.NumberFilteredResults,
        rowsPerPage: event.target.value,
        reloading: false
      });
    }).catch((error) => {
      this.setState({
        reloading: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  reloadTableBySearch(color, opt, salesChannels, reservation, stock) {
    this.setState({ reloading: true });
    this.l4ListAPI.getMinimizedL4List(this.props.negotiationLot.L1ID, STARTING_TABLE_PAGE, this.state.rowsPerPage, this.state.orderBy, this.state.order, color, opt, salesChannels, reservation, stock).then((response) => {
      this.setState({
        tableData: response.data.CarList,
        count: response.data.NumberFilteredResults,
        page: STARTING_TABLE_PAGE,
        reloading: false
      });
    }).catch((error) => {
      this.setState({
        reloading: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  handleConfirmForceSave = () => {
    this.setState({
      loading: false,
      openDialog: true,
      confirmationFunction: () => this.handleSubmitSalesChannels(true, true),
      cancelFunction: this.handleCloseDialog
    });
  };

  handleSubmitSalesChannels = (ForceSave, isToChangeReservations) => {
    this.setState({ loading: true })
    this.l4ListAPI.updateBulkSalesChannelByL4(this.state.selectedCars, this.state.selectedSaleChannels.map(o => o.value), ForceSave, isToChangeReservations).then(() => {
      this.setState({
        loading: false,
        success: true
      });
      setTimeout(() => {
        this.reloadTable();
        this.handleClearState();
        this.handleCloseDialog();
      }, 500)
    }).catch((error) => {
      let errorMessage = handleServerError(error);
      if (errorMessage.indexOf('cancelem as mesmas') > -1) {
        this.setState({
          confirmationQuestion: 'Tem a certeza que pretende MODIFICAR OS CANAIS DE VENDA das viaturas?',
          confirmationMessage: 'As viaturas da marca ' + this.props.negotiationLot.Brand + ' e modelo ' + this.props.negotiationLot.Model +
            ' possuem reservas associadas. A modificação terá impacto sobre as reservas.'
        })
        this.handleConfirmForceSave();
      }
      else {
        this.setState({
          loading: false,
          success: false,
          openError: true,
          alertMessage: errorMessage
        });
        this.handleClose();
      }
    });
  };

  handleOpenSaleChannels = () => {
    this.getHeaderInformation();
    this.reloadTable();
    this.setState({ openCVDialog: true })
  };

  handleChangeSelect = name => value => {
    this.setState({ [name]: value });
  };

  handleCheckAll = event => {
    if (event.target.checked) {
      let idList = this.state.tableData.map(o => o.L4ID);
      let completeList = this.state.selectedCars.concat(idList);
      this.setState({ allSelected: true, selectedCars: completeList });
    }
    else {
      this.setState({ allSelected: false, selectedCars: [] });
    }
    this.detectChange();
  }

  handleCheck = (id) => {
    const { selectedCars } = this.state;

    if (selectedCars.indexOf(id) > -1) {
      selectedCars.splice(selectedCars.indexOf(id), 1);
      this.setState({ allSelected: false, selectedCars });
    }
    else {
      selectedCars.push(id);
      this.setState({ selectedCars });
    }
    this.detectChange();
  };

  isSelected = id => {
    return this.state.selectedCars.indexOf(id) > -1;
  }

  handleCheckSaleChannel = (event, saleChannel) => {
    const { selectedSaleChannels } = this.state;

    if (event.target.checked) {
      selectedSaleChannels.push(saleChannel)
    } else {
      selectedSaleChannels.splice(selectedSaleChannels.findIndex(o => o.value === saleChannel.value), 1);
    }

    this.setState({ selectedSaleChannels });
    this.detectChange();
  }

  detectChange = () => {
    this.setState({ changedValueDetected: true });
  }

  renderSaleChannelList() {
    let saleChannelLabels = this.state.selectedSaleChannels.map(o => o.label);

    return this.state.saleChannelData.map(saleChannel => {
      return (
        <Grid item xs={12} sm={12} key={saleChannel.value}>
          <FormControlLabel
            control={
              <Checkbox
                color='secondary'
                checked={saleChannelLabels.indexOf(saleChannel.label) > -1}
                onClick={(e) => this.handleCheckSaleChannel(e, saleChannel)}
              />}
            label={saleChannel.label}
          />
        </Grid>
      );
    });
  };

  renderTableRecords(aCarList) {
    const { classes } = this.props;
    if (aCarList.length > 0) {
      const l4List = aCarList.map(carItem => {
        const isSelected = this.isSelected(carItem.L4ID);
        return (
          <TableRow key={carItem.L4ID} tabIndex={-1} className={classes.tblRow}>
            <TableCell className={classNames(classes.tblBorder, classes.iconswidth, classes.textCenter)} component='th' scope='row' padding='none'>
              <Checkbox checked={isSelected} onClick={() => this.handleCheck(carItem.L4ID)} className={classes.checkboxSize} />
            </TableCell>
            <TableCell className={classNames(classes.tblBorder, classes.cellPadding)} component='th' scope='row' padding='none'>
              {StringAllOptionals(carItem.NegotiatedOptionals, carItem.AnnouncedOptionals, this.props)}
            </TableCell>
            <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
              {carItem.ColourDescription}
            </TableCell>
            <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
              {carItem.LicensePlate}
            </TableCell>
            <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
              {FormatDate(carItem.LicensePlateDate)}
            </TableCell>
            <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
              {carItem.SaleChannels.map(cv => cv.label).join(' || ')}
            </TableCell>
            <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
              {carItem.Booking === true ? <CheckIcon /> : null}
            </TableCell>
            <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
              {carItem.Stock === true ? <CheckIcon /> : null}
            </TableCell>
          </TableRow>
        );
      })
      return l4List;
    }
  }

  renderNoRecordMessages() {
    return NO_TABLE_DATA_MESSAGE;
  }


  render() {
    const { classes } = this.props;
    const { tableData, order, orderBy, rowsPerPage, page, count, reloading, loading, success, selectedCars } = this.state;
    const buttonClassname = classNames({ [classes.buttonSuccess]: success });
    let numSelected = selectedCars.length;
    let rowCount = tableData.length;

    return (
      <span>
        <Tooltip title='Alterar Canais de Venda' placement='bottom' >
          <Button variant='fab' color='primary' onClick={this.handleOpenSaleChannels} className={classNames(classes.button, classes.buttonSize)}
            disabled={this.props.LotStateID !== FP_PHASE || this.props.UserRoleType.indexOf(FP_GROUP) < 0}>
            <SalesChannelsIcon />
          </Button>
        </Tooltip>

        <Dialog
          fullWidth
          maxWidth='lg'
          open={this.state.openCVDialog}>

          <Paper className={classes.filterPaper}>
            <Grid container spacing={8}>
              <Grid item xs={12} sm={2}>
                <Grid container justify='center'>
                  <div className={classes.width100}>
                    <InputLabel htmlFor='colorSearch'>
                      COR
                    </InputLabel>
                    <ReactSelect
                      classes={classes}
                      options={this.state.colorSearchData}
                      components={components}
                      value={this.state.colorSearch}
                      onChange={this.handleChangeSelect('colorSearch')}
                      placeholder=''
                    />
                  </div>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Grid container justify='center'>
                  <div className={classes.width100}>
                    <InputLabel htmlFor='optionalSearch'>
                      OPCIONAIS
                    </InputLabel>
                    <ReactSelect
                      classes={classes}
                      options={this.state.optionalsSearchData}
                      components={components}
                      value={this.state.optionalsSearch}
                      onChange={this.handleChangeSelect('optionalsSearch')}
                      placeholder=''
                      isMulti
                      closeMenuOnSelect={false}
                    />
                  </div>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Grid container justify='center'>
                  <div className={classes.width100}>
                    <InputLabel htmlFor='SaleChannels'>
                      CANAL DE VENDA
                    </InputLabel>
                    <ReactSelect
                      classes={classes}
                      options={this.state.saleChannelData}
                      components={components}
                      value={this.state.saleChannelSearch}
                      onChange={this.handleChangeSelect('saleChannelSearch')}
                      placeholder=''
                      isMulti
                      closeMenuOnSelect={false}
                    />
                  </div>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={1}>
                <Grid container justify='center'>
                  <div className={classes.width100}>
                    <InputLabel htmlFor='reservationSearch'>
                      RESERVA
                    </InputLabel>
                    <ReactSelect
                      classes={classes}
                      options={this.state.trueFalseOptions}
                      components={components}
                      value={this.state.reservationSearch}
                      onChange={this.handleChangeSelect('reservationSearch')}
                      placeholder=''
                    />
                  </div>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={1}>
                <Grid container justify='center'>
                  <div className={classes.width100}>
                    <InputLabel htmlFor='stockSearch'>
                      STOCK
                    </InputLabel>
                    <ReactSelect
                      classes={classes}
                      options={this.state.trueFalseOptions}
                      components={components}
                      value={this.state.stockSearch}
                      onChange={this.handleChangeSelect('stockSearch')}
                      placeholder=''
                    />
                  </div>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={1}>
                <Grid container justify='flex-end'>
                  <Grid item>
                    <Tooltip title='Limpar Filtros' placement='bottom' >
                      <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} 
                          onClick={this.handleClearSearchFilter} >
                        <ClearIcon />
                      </Button>
                    </Tooltip>
                  </Grid>
                  <Grid item>
                    <Tooltip title='Aplicar Filtro' placement='bottom' >
                      <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} 
                          onClick={() => { this.reloadTableBySearch(this.state.colorSearch.value, this.state.optionalsSearch.map(o => o.value), this.state.saleChannelSearch.map(o => o.value),
                            this.state.reservationSearch != null ? this.state.reservationSearch.value : null, this.state.stockSearch != null ? this.state.stockSearch.value : null) }} >
                        <ApplyIcon />
                      </Button>
                    </Tooltip>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>

          <DialogContent>
            <Grid container className={classes.gridRoot}>
              <Grid item xs={12} sm={2}>
                <Typography variant='subheading' id='selectAnnouncedOptionals' className={classes.marginSelectOptionals}>
                  Selecionar Canais de Venda:
                </Typography>
                {this.renderSaleChannelList()}
              </Grid>
              <Grid item xs={12} sm={10}>
                <span className={classes.textOptionals}>*
                  <span className={classes.textAquaBlue}>Opcionais Negociados e Anunciados</span>
                  <span> || </span>
                  <span className={classes.textGrassGreen}>Opcionais Negociados</span>
                  <span> || </span>
                  <span>Opcionais Anunciados</span>
                </span>
                <Paper className={classes.paperRoot}>
                  <Table>
                    <TableHead className={classes.tblHead}>
                      <TableRow className={classes.headerHeight}>
                        <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
                          <Checkbox
                            indeterminate={numSelected > 0 && numSelected < rowCount}
                            checked={this.state.allSelected}
                            onChange={this.handleCheckAll}
                            inputProps={{ 'aria-label': 'select all cars' }}
                            className={classes.checkboxSize}
                          />
                        </TableCell>
                        {headerData.map(column => {
                          return (
                            <TableCell
                              padding='none'
                              key={column.id}
                              sortDirection={orderBy === column.id ? order : false}
                              className={classNames(classes.tblHeadT, classes.tblBorderHead, classes.textCenter, column.sort ? classes.headerCellPadding : null)}
                            >
                              {column.sort ?
                                <TableSortLabel
                                  className={classes.tblHeadT}
                                  active={orderBy === column.id}
                                  direction={order}
                                  onClick={this.handleRequestSort(column.id)}
                                  classes={{ icon: classes.tblSort }}
                                >
                                  {column.label}
                                </TableSortLabel>
                                : column.label}
                            </TableCell>
                          );
                        }, this)}
                      </TableRow >
                    </TableHead>
                    <TableBody>
                      {this.renderTableRecords(tableData)}
                    </TableBody>
                  </Table>
                  {(!rowCount) ? this.renderNoRecordMessages() : null}
                  {reloading && <LinearProgress />}
                  <TablePagination
                    component='div'
                    count={count}
                    rowsPerPage={rowsPerPage}
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    labelRowsPerPage={'Resultados por página:'}
                    page={page}
                    backIconButtonProps={{ className: classes.pageButton }}
                    nextIconButtonProps={{ className: classes.pageButton }}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    labelDisplayedRows={({ from, to, count }) => `A mostrar resultados ${from}-${to} de ${count}`}
                    classes={{ toolbar: classes.tblFooter }}
                  />
                </Paper>
              </Grid>
            </Grid>
          </DialogContent>

          <Divider />
          <DialogActions disableActionSpacing>
            <Toolbar>
              <Tooltip title='Cancelar' placement='bottom' >
                <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleClickCancel}>
                  <CloseIcon />
                </Button>
              </Tooltip>
              <Tooltip title='Guardar' placement='bottom' >
                <Button disabled={loading} variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize, buttonClassname)} onClick={() => { this.handleSubmitSalesChannels(false) }}>
                  {success ? <CheckIcon /> : <SaveIcon />}
                </Button>
              </Tooltip>
              {loading && <CircularProgress size={48} color='primary' className={classes.fabProgress} />}
            </Toolbar>
          </DialogActions>

        </Dialog>

        <Dialog
          open={this.state.openDialog}
          onClose={this.handleCloseDialog}
        >
          <ConfirmationDialog
            openConfirmationDialog={this.state.openDialog}
            handleClose={this.handleCloseDialog.bind(this)}
            confirmationQuestion={this.state.confirmationQuestion}
            confirmationMessage={this.state.confirmationMessage}
            confirmationFunction={this.state.confirmationFunction.bind(this)}
            cancelFunction={this.state.cancelFunction.bind(this)}
            loading={this.state.loading}
            success={this.state.success}
          />
        </Dialog>

        <SnackbarAlert openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </span >
    )
  }
}

const mapStateToProps = state => ({
  ...state,
});

export default connect(mapStateToProps)(withStyles(styles)(FirmPurchasesSaleChannels))


// WEBPACK FOOTER //
// ./src/components/FirmPurchases/EditLots/FirmPurchasesSaleChannels.js